import { render, staticRenderFns } from "./ScopeOfWork.vue?vue&type=template&id=eb15959a&scoped=true"
import script from "./ScopeOfWork.vue?vue&type=script&lang=ts"
export * from "./ScopeOfWork.vue?vue&type=script&lang=ts"
import style0 from "./ScopeOfWork.vue?vue&type=style&index=0&id=eb15959a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb15959a",
  null
  
)

export default component.exports